<template>
  <div id="login">
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout" top>
      {{ snackbarInfo }}
      <v-btn dark text @click="snackbar = false">关闭</v-btn>
    </v-snackbar>

    <!-- 修改密码页面 -->
    <div class="download" v-if="$store.state.changePassword">
      <div style="opacity: 0.5;background-color: #101010;position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;">
      </div>
      <ChangePassword></ChangePassword>
    </div>

    <!-- 左上角的 Logo 和系统名称 -->
    <v-toolbar flat dense class="toolbar">
      <v-img src="logo2025.png" contain max-width="240" alt="Logo" class="mr-2"></v-img>
    </v-toolbar>

    <v-toolbar-title class="system-name">长光卫星统一交付平台</v-toolbar-title>

    <div class="login_content">
      <v-card class="login" elevation="0" style="background: none">
        <!-- 欢迎登录标题 -->
        <div class="welcome-text">
          <h2>欢迎登录</h2>
          <div class="underline"></div>
        </div>

        <v-text-field v-model="username" dark append-icon="mdi-account" type="text"
          placeholder="请输入账号" @keyup.enter="handleLogin" @blur="checkNeedPhoneCode"></v-text-field>

        <v-text-field v-model="password" placeholder="请输入密码" dark
          :type="pwdShow ? 'text' : 'password'" :error="false" :error-messages="errorMessages"
          @keyup.enter="handleLogin"
          :append-icon="pwdShow ? 'mdi-eye' : 'mdi-eye-off'" @click:append="pwdShow = !pwdShow">
        </v-text-field>

        <!-- 手机验证码（按需显示） -->
        <div v-if="needPhoneCode" class="verify-item">
          <v-text-field v-model="varifyCode" dark placeholder="请输入验证码" type="text"
            @keyup.enter="handleLogin" class="verify-input" hide-details></v-text-field>
          <v-btn @click="getPhoneCode" :disabled="codeLoading || countdown > 0"
            class="varify-btn" dark small>
            {{ codeLoading ? '获取中...' : (countdown > 0 ? countdown + 's后重新获取' : '获取验证码') }}
          </v-btn>
        </div>
        <p v-if="smsSendMsg" class="sms-tip">{{ smsSendMsg }}</p>

        <v-btn type="submit" color="primary" class="login-button" @click="handleLogin" :disabled="loginDisabled">
          {{ loading ? '登录中...' : '登 录' }}
        </v-btn>
      </v-card>
    </div>

    <!-- 提示说明 -->
    <!-- <div class="login-tip">
      <p><strong>提示说明：</strong></p>
      <p>公司内部人员账号密码与Manage系统账号密码一致</p>
      <p>外部合作商请联系对应商务经理创建账号密码</p>
    </div> -->
  </div>
</template>

<script>
import ChangePassword from "../components/main/ChangePassword"
import { JSEncrypt } from 'jsencrypt'

export default {
  name: "Login",
  components: { ChangePassword },
  data() {
    return {
      snackbar: false,
      snackbarColor: "",
      snackbarInfo: "",
      timeout: 3000,
      username: '',
      password: '',
      pwdShow: false,
      errorMessages: '',
      // 验证码相关
      varifyCode: '',
      loading: false,
      codeLoading: false,
      publicKey: '',
      needPhoneCode: false,
      smsSendMsg: '',
      countdown: 0,
      countdownTimer: null
    }
  },
  watch: {
    username(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.smsSendMsg = ''
        this.varifyCode = ''
        this.stopCountdown()
      }
    }
  },
  computed: {
    loginDisabled() {
      return this.loading ||
        !this.username.trim() ||
        !this.password.trim() ||
        (this.needPhoneCode && !this.varifyCode.trim())
    }
  },
  methods: {
    showMessage(msg, type = 'error') {
      this.snackbarColor = type
      this.snackbarInfo = msg
      this.snackbar = true
    },

    // RSA 加密
    encryptData(data, publicKey) {
      if (!publicKey) {
        throw new Error('公钥为空，无法加密')
      }
      try {
        const encrypt = new JSEncrypt()
        encrypt.setPublicKey(publicKey)
        const encrypted = encrypt.encrypt(data)
        if (!encrypted) {
          throw new Error('加密失败')
        }
        return encrypted
      } catch (error) {
        console.error('加密过程出错:', error)
        throw error
      }
    },

    // 获取 RSA 公钥
    async getPublicKey() {
      try {
        const res = await this.axios.get('/loginapi/getRsaPubKey')
        console.log('获取到的公钥为：' + (res.data.publicKey))
        if (res.status === 200) {
          return res.data.publicKey
        } else {
          this.showMessage(res.data.message || '获取公钥失败')
          const error = new Error(res.data.message)
          error._handled = true
          throw error
        }
      } catch (error) {
        if (!error._handled) {
          this.showMessage('获取公钥请求失败，请检查网络')
        }
        throw error
      }
    },

    // 检查是否需要手机验证码
    checkNeedPhoneCode() {
      if (!this.username.trim() || !this.publicKey) {
        return
      }
      this.needPhoneCodeCheck(this.username, this.publicKey).then(result => {
        this.needPhoneCode = result
      }).catch(() => {})
    },

    async needPhoneCodeCheck(username, publicKey) {
      try {
        let data = username + '|' + Date.now()
        data = this.encryptData(data, publicKey)
        let param = new FormData()
        param.append('account', data)
        const res = await this.axios.post('/loginapi/phoneMessage', param)
        console.log('获取到的是否需要验证码结果为：' + JSON.stringify(res.data.data))
        if (res.data.status === 200) {
          return false
          // return res.data.data
        } else {
          this.showMessage(res.data.message || '获取需要验证码失败')
          const error = new Error(res.data.message)
          error._handled = true
          throw error
        }
      } catch (error) {
        if (!error._handled) {
          this.showMessage('获取是否需要验证码请求失败，请检查网络')
        }
        throw error
      }
    },

    // 获取手机验证码
    async getPhoneCode() {
      if (!this.username.trim()) {
        this.showMessage('请输入账号')
        return
      }
      this.codeLoading = true
      try {
        let data = this.username + '|' + Date.now()
        data = this.encryptData(data, this.publicKey)
        let param = new FormData()
        param.append('account', data)
        const res = await this.axios.post('/loginapi/sendLoginMessageCode', param)
        if (res.data.status === 200) {
          const code = res.data.data
          if (code) {
            this.smsSendMsg = '验证码已发送到您的手机号：' + code + '，请查收！若手机号有误，请联系商务经理修改。'
            this.startCountdown(300)
          }
        } else {
          this.showMessage(res.data.message || '获取验证码失败')
        }
      } catch (error) {
        this.showMessage('获取验证码请求失败，请检查网络')
        console.error('获取验证码失败:', error)
      } finally {
        this.codeLoading = false
      }
    },

    startCountdown(seconds) {
      this.stopCountdown()
      this.countdown = seconds
      this.countdownTimer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          this.stopCountdown()
        }
      }, 1000)
    },

    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
      this.countdown = 0
    },

    // 登录成功后的处理
    async postLoginProcess(userData) {
      document.cookie = `loginToken=${userData.loginToken}; path=/; domain=jl1.cn`
      const userRes = await this.axios.get('/loginapi/getUser', {
        withCredentials: true
      })
      if (userRes.data && userRes.data.data && userRes.data.data.roleId) {
        userData.roleId = userRes.data.data.roleId
      } else {
        console.log('获取到的角色为null')
        userData.roleId = null
      }
      localStorage.setItem('user', JSON.stringify(userData))
      localStorage.setItem('token', userData.token || '')
      localStorage.setItem('loginToken', userData.loginToken || '')
      // 清除可能残留的强制改密码标记（路由守卫依赖）
      localStorage.removeItem('forceChangePwd')
      this.$store.state.user.forceChangePwd = false
      this.$store.state.changePassword = false
      // 持久化到 localStorage（路由守卫依赖）
      const userId = userData.account || userData.id || userData.userId || ''
      localStorage.setItem('userId', userId)
      localStorage.setItem('userName', userData.name || '')
      localStorage.setItem('role', userData.roleId || '')
      // 同步到 Vuex store
      this.$store.state.account = userId
      this.$store.state.user.userId = userId
      this.$store.state.user.userName = userData.name || ''
      this.$store.state.user.role = userData.roleId || ''
      this.$store.state.user.token = userData.token || ''
      this.$store.state.user.loginToken = userData.loginToken || ''
      this.$store.state.user.logined = true
      console.log('获取到的用户信息为：' + JSON.stringify(userData))
      return userData
    },

    // 带 RSA 加密的登录请求
    async systemLogin(username, password, validCode, publicKey) {
      try {
        let data = username + '|' + password + '|' + validCode + '|' + Date.now()
        data = this.encryptData(data, publicKey)
        let param = new FormData()
        param.append('loginCode', data)
        param.append('system', 'pan')
        const res = await this.axios({
          method: 'post',
          url: '/loginapi/systemLogin',
          data: param,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })

        if (res.data.status === 200) {
          return await this.postLoginProcess(res.data.data)
        }

        // 保留原有强制修改密码等逻辑
        const msg = res.data.message || ''
        const resData = res.data.data || ''

        if (res.data.status === 500 && msg === '弱密钥无法登陆，请修改密码') {
          this.$store.state.changePassword = true
          this.$store.state.persistent = true
          this.$store.state.account = this.username
          this.$store.state.user.forceChangePwd = true
          this.$store.state.user.logined = false
          this.$store.state.user.userId = ''
          localStorage.setItem('forceChangePwd', 'true')
          this.snackbarColor = 'warning'
          this.snackbarInfo = '弱密钥无法登陆，请修改密码'
          this.snackbar = true
          this.password = ''
          if (res.data.data && res.data.data.token) {
            localStorage.setItem('token', res.data.data.token)
            localStorage.setItem('loginToken', res.data.data.loginToken)
            this.$store.state.user.token = res.data.data.token
            this.$store.state.user.loginToken = res.data.data.loginToken
          }
          const error = new Error(msg)
          error._handled = true
          throw error
        } else if (res.data.status === 40306) {
          this.$store.state.changePassword = true
          this.$store.state.persistent = true
          this.$store.state.account = this.username
          this.$store.state.user.forceChangePwd = true
          this.$store.state.user.logined = false
          this.$store.state.user.userId = ''
          localStorage.setItem('forceChangePwd', 'true')
          this.snackbarColor = 'warning'
          this.snackbarInfo = '当前为系统初始默认密码，请修改密码'
          this.snackbar = true
          if (res.data.data && res.data.data.token) {
            localStorage.setItem('token', res.data.data.token)
            localStorage.setItem('loginToken', res.data.data.loginToken)
            this.$store.state.user.token = res.data.data.token
            this.$store.state.user.loginToken = res.data.data.loginToken
          }
          const error = new Error('40306')
          error._handled = true
          throw error
        } else if (res.data.status === 500 && resData === '账号已锁定，解锁请联系商务经理') {
          this.errorMessages = resData
          const error = new Error(resData)
          error._handled = true
          throw error
        } else if (res.data.status === 500 && typeof resData === 'string' && resData.substring(0, 4) === '密码错误') {
          this.errorMessages = resData
          const error = new Error(resData)
          error._handled = true
          throw error
        } else if ((res.data.status === 200 && res.data.data && res.data.data.isFreezed == 1)) {
          this.errorMessages = '用户名或密码不对'
          const error = new Error('用户名或密码不对')
          error._handled = true
          throw error
        } else {
          this.showMessage(resData || msg || '登录失败')
          const error = new Error(resData || msg || '登录失败')
          error._handled = true
          throw error
        }
      } catch (error) {
        if (!error._handled) {
          this.showMessage('登录请求失败，请检查网络')
        }
        throw error
      }
    },

    // 登录按钮处理
    handleLogin() {
      if (!this.username.trim()) {
        this.showMessage('请输入账号')
        return
      }
      if (!this.password.trim()) {
        this.showMessage('请输入密码')
        return
      }
      if (this.needPhoneCode && !this.varifyCode.trim()) {
        this.showMessage('请输入验证码')
        return
      }
      if (this.loginDisabled) {
        return
      }

      this.loading = true

      this.systemLogin(this.username, this.password, this.varifyCode, this.publicKey)
        .then(userData => {
          this.showMessage(`欢迎回来，${userData.name}！`, 'success')
          this.$router.push('/home')
        })
        .catch(() => {
          // 错误提示已在 systemLogin 中处理
        })
        .finally(() => {
          this.loading = false
        })
    },

    isValidPassword(password) {
      const regex = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,}$/
      return regex.test(password)
    }
  },
  mounted() {
    this.getPublicKey()
      .then(publicKey => {
        this.publicKey = publicKey
      })
      .catch(() => {})
    this.$nextTick(() => {
      this.$el.querySelector('input[type="text"]').focus()
    })
  },
  beforeDestroy() {
    this.stopCountdown()
  }
}
</script>

<style scoped>
#login {
  width: 100%;
  height: 100%;
  background-image: url("/pan2025.jpg");
  background-size: 100% 100%;
  position: relative;
}

.login_content {
  position: absolute;
  top: 36%;
  left: 40%;
  background: rgba(255, 255, 255, 0.35);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  padding: 30px;
  width: 400px;
  max-width: 80%;
  margin-top: 8px;
}

.login {
  width: 382px;
  height: auto;
  margin-right: 30px;
  background-size: cover;
  background-position: center;
}

.system-name {
  font-size: 33px;
  font-weight: normal;
  color: white;
  font-family: SourceHanSansSC-regular;
  position: absolute;
  top: 31%;
  left: 42%;
}

.download {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 5;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toolbar {
  background: transparent;
  background-color: transparent !important;
  color: transparent;
  position: absolute;
  top: 23px;
  left: 27px;
}

.login-button {
  margin-top: 20px;
  width: 100%;
  background: linear-gradient(225.45deg, rgba(50, 197, 255, 1) -0.21%, rgba(20, 66, 170, 1) 101.4%);
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  border-radius: 8px;
  padding: 12px 0;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
  transition: box-shadow 0.3s ease;
}

.login-button:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
}

.welcome-text {
  text-align: center;
  color: white;
  margin-bottom: 10px;
  height: auto;
}

.welcome-text h2 {
  margin: 0;
  font-size: 26px;
  font-weight: normal;
}

.underline {
  width: 96%;
  height: 2px;
  background-color: white;
  margin: 10px auto 0 auto;
}

/* 验证码区域 */
.verify-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.verify-input {
  flex: 1;
}

.varify-btn {
  white-space: nowrap;
  min-width: 130px;
  height: 36px !important;
  font-size: 12px;
  margin-top: 6px;
  background: linear-gradient(225.45deg, rgba(50, 197, 255, 1) -0.21%, rgba(20, 66, 170, 1) 101.4%);
  color: white !important;
  border-radius: 4px;
}

.sms-tip {
  color: #ffd700;
  font-size: 12px;
  margin: 5px 0 0 0;
}

/* 提示说明 */
.login-tip {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  text-align: center;
}

.login-tip p {
  margin: 2px 0;
}
</style>
